import _ from 'lodash'
import React from 'react'
import {graphql} from 'gatsby'
import glamorous from 'glamorous'

/* eslint-disable-next-line import/no-named-as-default */
import Default from '../layouts/default'
import {mediaMaxWidth, sm} from '../css/themes'
import Map from '../components/map'
import MediaPreview from '../components/media-preview'
import {H2, H3, UL, LI} from '../components/common'

const MediaPreviewWrapper = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  [mediaMaxWidth(sm)]: {
    justifyContent: 'center',
  },
})

const renderMediaPreviews = edges => (
  <MediaPreviewWrapper>
    {_.map(edges, ({node: {frontmatter: {image, title, author, review}, fields: {path}}}) => {
      return <MediaPreview key={title} title={title} author={author} path={path} image={image} />
    })}
  </MediaPreviewWrapper>
)

/*
 * Location
 */

const Location = () => (
  <React.Fragment>
    <H3>🗺 Here</H3>
    <Map type="location" location="NYC" />
  </React.Fragment>
)

/*
 * Reading
 */
const Reading = ({books}) => (
  <React.Fragment>
    <H3>📖 Reading</H3>
    {renderMediaPreviews(books)}
  </React.Fragment>
)

/*
 * Doing
 */
const Doing = () => (
  <React.Fragment>
    <H3>💻 Doing</H3>
    <UL>
      <LI>Keybase</LI>
      <LI>This website</LI>
      <LI>Some experiments with serverless projects</LI>
    </UL>
  </React.Fragment>
)

/*
 * Done
 */
const Done = () => (
  <React.Fragment>
    <H3>✔ Done</H3>
    <UL>
      <strike>
        <LI>Keybase</LI>
      </strike>
    </UL>
  </React.Fragment>
)

const Now = ({location, data}) => {
  return (
    <Default location={location}>
      <H2>Right Now I'm...</H2>
      <Location />
      <Doing />
      <Done />
      <Reading books={data.now.edges} />
    </Default>
  )
}

export default Now

export const pageQuery = graphql`
  query BooksReadingNow {
    now: allMarkdownRemark(filter: {frontmatter: {title: {in: ["Sapeins", "Isle of Dogs"]}}}) {
      edges {
        node {
          ...reviewAll
        }
      }
    }
  }
`
